module.exports = __webpack_public_path__ + "static/media/md-redo.d18a7df9.svg";